//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Card, Evaluation, StarLevel} from '@/components';

export default {
  name: 'hotel-introduce',
  components: {
    Card,
    Evaluation,
    StarLevel,
  },
  props: {
    introduction: {
      type: Object,
      default(){
        return {};
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/HotelIntroduce.vue